/** Blog routes carry their own locale prefix (see utils/blog/paths.ts, mirrored
    in gatsby-node.js), so they must never be prefixed a second time here. */
export const isBlogPath = (path: string) =>
  path === "/blog" || path.startsWith("/blog/");

export const localePath = (path: string, language?: string | null): string =>
  language === "pt" && !isBlogPath(path) ? `/pt${path}` : path;

export const stripLocale = (pathname: string): string =>
  pathname.replace(/^\/pt(?=\/|$)/, "");

export const localePrefix = (pathname: string): string =>
  /^\/pt(\/|$)/.test(pathname) ? "/pt" : "";

export const pageLang = (pathname: string): string =>
  localePrefix(pathname) ? "pt" : "en";
